import { render, staticRenderFns } from "./FeedbackEmailProposes.vue?vue&type=template&id=2fc50e44&scoped=true"
import script from "./FeedbackEmailProposes.vue?vue&type=script&lang=js"
export * from "./FeedbackEmailProposes.vue?vue&type=script&lang=js"
import style0 from "./FeedbackEmailProposes.vue?vue&type=style&index=0&id=2fc50e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc50e44",
  null
  
)

export default component.exports